<template>
  <div
    class="zt-radiobutton w-full flex flex-col flex-wrap min-w-0 flex-grow h-auto mt-3"
    :class="radioButtonClasses"
  >
    <div class="zt-radiobutton-slot relative w-100 items-center flex mb-1">
      <div class="zt-input-radiobutton relative mr-3 flex-inline select-none">
        <input
          class="w-full h-full cursor-pointer absolute opacity-0"
          type="radio"
          v-bind="$attrs"
          :value="value"
          :name="name"
          :id="componentId"
          :checked="isChecked"
          @change="toggleValue"
        />
        <zt-icon
          class="zt-radiobutton-icon w-full"
          :name="iconName"
          :class="rippleClass"
        />
        <div
          class="zt-radiobutton-ripple overflow-hidden rounded-full cursor-pointer absolute pointer-events-none"
          :class="rippleClass"
        />
      </div>
      <label
        class="zt-radiobutton-label mb-0 items-center flex-inline flex-auto h-auto cursor-pointer select-none"
        :for="componentId"
      >
        <slot />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ztRadioButton',
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    name: { type: String, default: '' },
    value: {},
    color: { type: String, default: 'primary' },
    modelValue: { type: [String, Number], default: '' },
  },
  data() {
    return {
      componentId: 'radio-' + Math.random().toString(36).substring(2, 9),
    }
  },
  computed: {
    radioButtonClasses() {
      return (this.$attrs.disabled === '' || this.$attrs.disabled === true)
        ? 'zt-radiobutton--disabled' : ''
    },
    isChecked() {
      return this.modelValue === this.value
    },
    iconName() {
      return this.isChecked ? 'circle-dot' : 'circle'
    },
    rippleClass() {
      if (this.isChecked) {
        const colorLevel = this.color === 'primary' || this.color === 'secondary' ? '-200' : ''
        return 'text-zt-' + this.color + colorLevel
      }
      return null
    },
  },
  methods: {
    toggleValue() {
      if (this.$attrs.disabled) return
      this.$emit('update:modelValue', this.value)
    },
  },
}
</script>

<style scoped lang="css" src="../../../../styles/components/ztRadioButton.css"></style>
